import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import sagaHelpers from './helpers/sagaHelpers';
import userOfficeGroupsSaga from './userOfficeGroups/saga';
import usersSaga from './users/saga';
import userOfficesSaga from './offices/saga';
import userManagementSaga from './userManagement/saga';
import profileSaga from './profile/saga';
import applicationsRequestsSaga from './applications/requestsSaga';
import applicationsCompletedSaga from './applications/completedSaga';
import userApplicationsSaga from './user/saga';
import predefinedTextsSaga from './settings/saga';
import administrativeFeesSaga from './administrativeFees/saga';
import assignSolverSaga from './assignSolver/saga';
import assignGarantSaga from './assignGarant/saga';
import professionsSaga from './professions/saga';
import requestTypesSaga from './requestTypes/saga';
import primaryManagersSaga from './primaryManagers/saga';

export default function* rootSaga() {
  yield all([
    authSagas(),
    sagaHelpers(),
    userOfficeGroupsSaga(),
    usersSaga(),
    userOfficesSaga(),
    requestTypesSaga(),
    userManagementSaga(),
    profileSaga(),
    applicationsRequestsSaga(),
    applicationsCompletedSaga(),
    userApplicationsSaga(),
    predefinedTextsSaga(),
    administrativeFeesSaga(),
    assignSolverSaga(),
    assignGarantSaga(),
    professionsSaga(),
    primaryManagersSaga()
  ]);
}
